import { render, staticRenderFns } from "./double-journal.vue?vue&type=template&id=6b44a638&scoped=true"
import script from "./double-journal.vue?vue&type=script&lang=js"
export * from "./double-journal.vue?vue&type=script&lang=js"
import style0 from "./double-journal.vue?vue&type=style&index=0&id=6b44a638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b44a638",
  null
  
)

export default component.exports